import { useEffect } from 'react'
import { doc, getDoc, onSnapshot } from 'firebase/firestore'
import { db } from '../lib/firebase'

const CustomCSSLoader = () => {
    useEffect(() => {
        // Initial load
        loadCustomCSS()

        // Real-time listener for CSS updates
        const docRef = doc(db, 'customStyles', 'main')
        const unsubscribe = onSnapshot(docRef, (docSnap) => {
            if (docSnap.exists()) {
                applyCustomCSS(docSnap.data().css)
            }
        }, (error) => {
            console.warn('Custom CSS listener error:', error)
        })

        return () => unsubscribe()
    }, [])

    const loadCustomCSS = async () => {
        try {
            const docRef = doc(db, 'customStyles', 'main')
            const docSnap = await getDoc(docRef)

            if (docSnap.exists()) {
                const css = docSnap.data().css
                applyCustomCSS(css)
            }
        } catch (error) {
            console.warn('Could not load custom CSS:', error)
        }
    }

    const applyCustomCSS = (css) => {
        if (!css) return

        const styleId = 'custom-css-injected'
        let styleElement = document.getElementById(styleId)

        if (!styleElement) {
            styleElement = document.createElement('style')
            styleElement.id = styleId
            styleElement.setAttribute('data-custom-css', 'true')
            document.head.appendChild(styleElement)
        }

        styleElement.textContent = css
    }

    return null // This component doesn't render anything
}

export default CustomCSSLoader

